import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

//import { NotificationService } from '@progress/kendo-angular-notification';
import { NameValuePair } from 'src/app/models/NameValuePair';
import { MasterDataTypes } from 'src/app/models/SystemEnums';

@Injectable({
  providedIn: 'root',
})
export class NotifyServiceService {
  constructor(private _service: NotificationsService) {}

  showSuccess(message: string) {
    this._service.success('Success', message);
    // this.notificationService.show({
    //   content: message,
    //   cssClass: 'notification-success',
    //   animation: { type: 'slide', duration: 100 },
    //   position: { horizontal: 'right', vertical: 'bottom' },
    //   type: { style: 'success', icon: true },
    //   hideAfter: 2000,
    // });
  }

  showError(message: string) {
    this._service.error('Error', message);
    // this.notificationService.show({
    //   content: message,
    //   cssClass: 'notification-error',
    //   animation: { type: 'slide', duration: 100 },
    //   position: { horizontal: 'right', vertical: 'bottom' },
    //   type: { style: 'error', icon: true },
    //   hideAfter: 2000,
    // });
  }
}
